module.exports = "<label class=\"col-xs-3 control-label\">{{options.templateOptions.labelOptions.label}}</label>\n<div class=\"col-xs-8 col-sm-5\">\n    <formly-transclude></formly-transclude>\n</div>\n<span class=\"required-indicator pull-left\">{{options.templateOptions.required ? '*' : ''}}</span>";


//////////////////
// WEBPACK FOOTER
// ./static/js/app/layout/formly/wrappers/inline-input-group-options.html
// module id = 623
// module chunks = 1